import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { ApolloClient, ApolloQueryResult } from 'apollo-client'
import { NormalizedCache } from 'apollo-cache-inmemory'

import { Store } from '../../../reducers/index'
import { CalcBar, AddCaseBlock } from './InputCategoryStyles'
import InputCaseContainer from './InputCaseContainer'
import { DEFAULT_VALUES_QUERY, DefaultValues } from './defaultValuesQuery'
import { getProjectDefaultSpaceType } from '../../../reducers/project'
import { createCase } from '../../../actions/project'
import { Action } from '../../../actions/types'
import { recordEvent } from '../../../analytics'
import { getLocation } from '../../../location_changes/conversionHelper'

const AddCircle = require('./add_circle.svg')

type DefaultsResponse = ApolloQueryResult<{ defaultValues: DefaultValues }>

type Props = {
  defaultSpaceType: string
  createCase: (defaults: DefaultValues) => Action
}

class InputCategories extends React.Component<Props> {
  static contextTypes = {
    client: () => null
  }
  client: ApolloClient<NormalizedCache>

  // tslint:disable-next-line
  constructor(props: Props, context?: any) {
    super(props)
    this.client = context.client
    this.createCase = this.createCase.bind(this)
  }

  createCase() {
    this.client
      .query({
        query: DEFAULT_VALUES_QUERY,
        variables: {
          spaceId: this.props.defaultSpaceType,
          location: getLocation()
        }
      })
      .then(({ data: { defaultValues } }: DefaultsResponse) => {
        recordEvent('workspace', 'case-created')
        this.props.createCase(defaultValues)
      })
      .catch(err => {
        console.error('Error fetching default values', err.message)
      })
  }

  render() {
    return (
      <CalcBar style={{ marginLeft: '-25px', marginRight: '-25px' }}>
        <InputCaseContainer />

        <AddCaseBlock>
          <button onClick={this.createCase}>
            <img style={{ verticalAlign: 'bottom' }} src={AddCircle} alt="" />{' '}
            CREATE NEW CASE
          </button>
        </AddCaseBlock>
      </CalcBar>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  defaultSpaceType: getProjectDefaultSpaceType(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  createCase: (defaults: DefaultValues) => dispatch(createCase(defaults))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputCategories)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/InputCategories.tsx